
import { MODULE } from "@/config/modules";
import { AuthService } from "@/services/auth-service";
import { BrowserInfo } from "@/utils/browser";
import { IElectronPrinter } from "@/utils/electron/electron-printer";
import { SaleLayoutInfo } from "@/utils/sale-layouts/sale-layout-info";
import AppSaleLayoutEditElectronProperties from "./SaleLayoutEditElectronProperties.vue";
import AppSaleLayoutConditionsEditModal from "./SaleLayoutConditionsEditModal.vue";
import Vue from "vue";
import { SaleLayoutConf } from "@/models/sale-layout";
import { SaleService } from "@/services";


export default Vue.extend({
	data(){
		return {
			editElectronPropertiesLayoutId: 0,
			sortedList: [] as SaleLayoutInfo[],
			toEditConditionsLayout: null as SaleLayoutConf | null
		};
	},
	props: {
		title: {
			type: String,
			required: true
		},
		layouts: {
			type: Array as ()=>SaleLayoutInfo[],
			required: true
		},
		contactGroupId: {
			type: Number,
			required: true
		},
		printers: {
			type: Array as ()=>IElectronPrinter[],
			required: true
		},
		order: {
			type: Array as()=>number[],
			required: true
		}
	},
	computed: {
		canDeleteLayouts():boolean {
			return this.layouts.length > 1;
		},
		canCreateLayout():boolean {
			if (this.layouts.length < 1) {
				return true;
			}
			if (!AuthService.hasModule(MODULE.VERKOOPDOCUMENTEN_LAYOUT)){
				return false;
			}
			return true;
		},
		createLink():string{
			return `/settings/sale-layout/new?contactGroupId=${this.contactGroupId}`;
		},
		isElectron():boolean {
			return BrowserInfo.hasElectronConfigured();
		}
	},
	watch: {
		layouts: {
			immediate: true,
			handler(){
				this.sortedList = this.layouts;
				this.sortedList = this.layouts.sort((a,b)=>{
					let ia = this.order.indexOf(a.ID);
					let ib = this.order.indexOf(b.ID);
					if (ia == -1 || ib == -1) {
						return a.ID - b.ID;
					}
					return ia-ib;
				});
			}
		}
	},
	methods: {
		copyLayout(layout:SaleLayoutInfo){
			this.$emit("copy", layout);
		},
		deleleLayout(layout:SaleLayoutInfo){
			this.$emit("delete", layout);
		},
		editElectronProperties(layout:SaleLayoutInfo){
			this.editElectronPropertiesLayoutId = layout.ID;
		},
		saveOrder(){
			this.$emit("order", this.sortedList.map(l=>l.ID));
		},
		async editConditions(layout:SaleLayoutInfo){
			this.toEditConditionsLayout = await SaleService.getSaleLayout(layout.ID);
		}
	},
	components: {
		AppSaleLayoutEditElectronProperties,
		AppSaleLayoutConditionsEditModal
	},
	i18nEx: {
		componentPrefix: "components.sale-settings"
	}
});
